export default {
  "content": "<g fill=\"#D7D8DE\"><path d=\"M14 0H2C.897 0 0 .897 0 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2zm0 2l.001 6.615c-.505.527-1.944 1.813-4.001 1.813-1.445 0-2.261-.584-3.124-1.203C6.074 8.651 5.166 8 3.859 8c-.74 0-1.349.167-1.859.393V2zM2 14v-3.225C2.254 10.5 2.85 10 3.859 10c.634 0 1.094.308 1.852.851.98.703 2.201 1.577 4.289 1.577 1.67 0 3.021-.593 4.001-1.235V14z\"/><path d=\"M10 9c1.654 0 3-1.355 3-3.021s-1.346-3.021-3-3.021-3 1.355-3 3.021S8.346 9 10 9zm0-4.042c.552 0 1 .458 1 1.021S10.552 7 10 7s-1-.458-1-1.021c0-.562.448-1.021 1-1.021z\"/></g>",
  "attrs": {
    "height": "16",
    "viewBox": "0 0 16 16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};